module.exports = __webpack_public_path__ + "static/media/service1.350e58b1.jpg";